import type { TranslationKey } from "../locales";
import type { Enums } from "../types";

/**
 * This function returns the translation key associated with a given project invoice type.
 * @param type
 * @returns
 */
export function getProjectInvoiceTypeString(type: Enums<"outgoingInvoiceType">): TranslationKey {
	switch (type) {
		case "final-invoice":
			return "invoices.final_invoice";
		case "progress-invoice":
			return "invoices.progress_invoice";
		case "single-invoice":
			return "invoices.single_invoice";
	}
	return type;
}
